<template>
  <div class="container">
    <product-datatable />
  </div>
</template>

<script>
// import {
//   save_configuration,
//   get_configuration,
//   post,
//   error_message,
//   success_message,
// } from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import ProductDatatable from "./product_datatable/Index.vue";

export default {
  name: "RestaurantProducts",
  components: { GenericDropdown, ProductDatatable },
  data() {
    return {
      meta: {},
    };
  },
  methods: {},
  created() {},
};
</script>

<style></style>
